import { render, staticRenderFns } from "./RedirectOneDriveButton.vue?vue&type=template&id=4d7606c1&scoped=true"
import script from "./RedirectOneDriveButton.vue?vue&type=script&lang=ts"
export * from "./RedirectOneDriveButton.vue?vue&type=script&lang=ts"
import style0 from "./RedirectOneDriveButton.vue?vue&type=style&index=0&id=4d7606c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7606c1",
  null
  
)

export default component.exports